import { render, staticRenderFns } from "./LogInspectores.vue?vue&type=template&id=a41562c0&"
import script from "./LogInspectores.vue?vue&type=script&lang=js&"
export * from "./LogInspectores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports